<template>
  <div>Loading{{dotsDisplay}}</div>
</template>

<script>
    export default {
        name: "Loading",
        data() {
            return {
                dots: 0,
                dotsDisplay: ''
            }
        },
        methods: {
            updateDots() {
                this.dotsDisplay = '';
                for (let i = 0; i < this.dots; i++) {
                    this.dotsDisplay += '.'
                }
                this.dots++;
                this.dots %= 4;
            }
        },
        mounted() {
            setInterval(this.updateDots, 500);
        }
    }
</script>

<style scoped>
  div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
